var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.showNav)?[_c('TheNav')]:_vm._e(),_c('transition',{attrs:{"name":"slide-left","mode":"out-in"}},[_c('router-view')],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }